import React from "react";
import { Link } from "react-router-dom";
import { Clock3, Facebook, Instagram, MapPin, MessageCircle, Phone } from "lucide-react";
import logo from "../img/logo.png";
import { BUSINESS_INFO } from "../config";
import { trackContactClick } from "../utils/analytics";
import { scrollToElement } from "../utils/scrollUtils";

const productLinks = [
  { label: "Về Cưng Home", href: "/ve-cung-home" },
  { label: "Thanh toán & đặt cọc", href: "/chinh-sach-thanh-toan-dat-coc" },
  { label: "Tất cả sản phẩm", href: "/#products" },
  { label: "Sofa phòng khách", href: "/?type=Sofa#products" },
  { label: "Sofa chữ L", href: "/?type=Sofa%20L#products" },
  { label: "Sofa bed", href: "/?type=Sofa%20Bed#products" },
  { label: "Sofa may đo", href: "/?type=Sofa%20Xưởng#products" },
];

export default function Footer() {
  const handleProductLinkClick = (event, item) => {
    const isCurrentHomePage =
      item.href === "/#products" &&
      window.location.pathname === "/" &&
      !window.location.search;

    if (!isCurrentHomePage) return;

    event.preventDefault();
    window.history.replaceState(null, "", "/#products");
    scrollToElement("products");
  };

  return (
    <footer id="contact" className="footer mt-12 scroll-mt-24">
      <div className="mx-auto max-w-7xl px-4 py-10 sm:px-6 sm:py-12 lg:px-8">
        <div className="grid gap-9 md:grid-cols-2 lg:grid-cols-[1.15fr_1fr_0.8fr_0.9fr] lg:gap-10">
          <div>
            <img
              src={logo}
              alt="Cưng Home"
              className="h-12 w-36 object-contain brightness-0 invert"
            />
            <p className="mt-4 max-w-sm text-sm leading-6 text-white/70">
              Sofa và giường bọc nệm may đo theo không gian, hỗ trợ lựa chọn kích thước, màu sắc và chất liệu.
            </p>
            <a
              href={BUSINESS_INFO.messengerUrl}
              onClick={() => trackContactClick("Messenger footer CTA")}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-5 inline-flex min-h-11 items-center gap-2 rounded-md bg-[var(--color-primary)] px-4 text-sm font-semibold !text-white transition hover:bg-[#805b42]"
            >
              <MessageCircle className="h-4 w-4" />
              Tư vấn qua fanpage
            </a>
          </div>

          <div>
            <h2 className="font-sans text-sm font-bold uppercase text-white">Liên hệ</h2>
            <ul className="mt-4 space-y-3 text-sm">
              <li>
                <a href={BUSINESS_INFO.phoneHref} onClick={() => trackContactClick("Hotline footer")} className="flex min-h-11 items-start gap-3 py-1 md:min-h-0 md:py-0">
                  <Phone className="mt-0.5 h-4 w-4 shrink-0 text-[var(--color-primary-light)]" />
                  <span>
                    <span className="block font-semibold text-white">{BUSINESS_INFO.phone}</span>
                    <span className="mt-0.5 block text-white/55">Hotline và Zalo</span>
                  </span>
                </a>
              </li>
              <li>
                <a
                  href={BUSINESS_INFO.mapsUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex min-h-11 items-start gap-3 py-1 md:min-h-0 md:py-0"
                >
                  <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-[var(--color-primary-light)]" />
                  <span>
                    <span className="block font-semibold text-white">{BUSINESS_INFO.officeLabel}</span>
                    <span className="mt-0.5 block text-white/70">{BUSINESS_INFO.addressFull}</span>
                  </span>
                </a>
              </li>
              <li className="flex items-start gap-3 text-white/70">
                <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-[var(--color-primary-light)]" />
                <span>
                  <span className="block font-semibold text-white">{BUSINESS_INFO.workshopLabel}</span>
                  <span className="mt-0.5 block">{BUSINESS_INFO.workshopAreaShort}</span>
                </span>
              </li>
              <li className="flex items-start gap-3 text-white/70">
                <Clock3 className="mt-0.5 h-4 w-4 shrink-0 text-[var(--color-primary-light)]" />
                <span>Hỗ trợ tư vấn hằng ngày</span>
              </li>
            </ul>
          </div>

          <div>
            <h2 className="font-sans text-sm font-bold uppercase text-white">Sản phẩm</h2>
            <nav className="mt-4 flex flex-col items-start gap-2.5 text-sm" aria-label="Liên kết sản phẩm">
              {productLinks.map((item) => (
                <Link
                  key={item.href}
                  to={item.href}
                  onClick={(event) => handleProductLinkClick(event, item)}
                  className="flex min-h-11 items-center py-1 md:min-h-0 md:py-0"
                >
                  {item.label}
                </Link>
              ))}
            </nav>
          </div>

          <div>
            <h2 className="font-sans text-sm font-bold uppercase text-white">Kết nối</h2>
            <div className="mt-4 space-y-3 text-sm">
              <a
                href={BUSINESS_INFO.facebookUrl}
                onClick={() => trackContactClick("Facebook footer")}
                target="_blank"
                rel="noopener noreferrer"
                className="flex min-h-11 items-center gap-3 py-1 md:min-h-0 md:py-0"
              >
                <Facebook className="h-4 w-4 text-[var(--color-primary-light)]" />
                Fanpage Cưng Home
              </a>
              <a
                href={BUSINESS_INFO.messengerUrl}
                onClick={() => trackContactClick("Messenger footer")}
                target="_blank"
                rel="noopener noreferrer"
                className="flex min-h-11 items-center gap-3 py-1 md:min-h-0 md:py-0"
              >
                <MessageCircle className="h-4 w-4 text-[var(--color-primary-light)]" />
                Messenger
              </a>
              <a
                href={BUSINESS_INFO.instagramUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="flex min-h-11 items-center gap-3 py-1 md:min-h-0 md:py-0"
              >
                <Instagram className="h-4 w-4 text-[var(--color-primary-light)]" />
                Instagram
              </a>
              <a
                href={BUSINESS_INFO.zaloUrl}
                onClick={() => trackContactClick("Zalo footer")}
                target="_blank"
                rel="noopener noreferrer"
                className="flex min-h-11 items-center gap-3 py-1 md:min-h-0 md:py-0"
              >
                <Phone className="h-4 w-4 text-[var(--color-primary-light)]" />
                Zalo
              </a>
            </div>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-white/10 pt-5 text-xs text-white/50 sm:flex-row sm:items-center sm:justify-between">
          <p>© {new Date().getFullYear()} Cưng Home. All rights reserved.</p>
          <p>Sofa &amp; more · May đo theo yêu cầu</p>
        </div>
      </div>
    </footer>
  );
}
